const formControlModalCloneCheckSite = {
  from: 'CLONAR DE:',
  to: 'CLONAR A:',
  text: 'SELECCIONE LOS TIPOS DE SERVICIO QUE DESEA CLONAR:'
};

export default formControlModalCloneCheckSite;
